import {ProductCostingBomReportModel} from "./product-costing-bom-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-product-costing-bom-report-page",
    templateUrl: "./product-costing-bom-report-page.component.html",
    providers: [provideReportModel(ProductCostingBomReportModel)]
})
export class ProductCostingBomReportPageComponent extends AbstractReportPage {
    constructor(public model: ProductCostingBomReportModel) {
        super();
    }
}
